import { Component, Inject, ElementRef, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { first } from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NodoEstructuraJerarquica } from 'app/main/models/nodo-estructura-jerarquica.model';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { MatDialog } from '@angular/material/dialog';

import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatTabsModule} from '@angular/material/tabs';
import { EstructuraJerarquicaService } from 'app/main/services/estructura-jerarquica.service';
import {SelectionModel} from '@angular/cdk/collections';
import { TokenStorageService } from 'app/main/auth/token-storage.service';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { MatTable,MatTableDataSource } from '@angular/material/table';
import { DialogBoxCopyEvaluationsToOtherStructureComponent} from './dialog-box-copy-evaluations-to-other-structure.component';



@Component({
  selector: 'app-dialog-box-add-node',
  templateUrl: './dialog-box-add-node.component.html',
  styleUrls: ['./dialog-box-add-node.component.scss']
})
export class DialogBoxAddNodeComponent {
  displayedColumns: string[] = ['select', 'nombre','estado','version','creador','dueno','fechaInicio','fechaFin'];
  displayedColumnsUsuarios: string[] = ['nombre','apellido','correoElectronico','tipo'];

  action: string;
  usuarioCtrl = new FormControl();
  filteredUsuarios: Observable<Usuario[]>;
  usuarios = [];
  LOCAL_DATA: any;
  selection = new SelectionModel<Evaluacion>(true, []);
  isOwnerUser = false;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('usuarioInput') usuarioInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild(MatTable, {static: true}) table: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    private storage: TokenStorageService,
    private service: UsersService,
    private serviceEJS: EstructuraJerarquicaService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxAddNodeComponent>,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);

    this.dialogRef.disableClose = true;
    this.LOCAL_DATA = data.obj;
    this.action = data.action;

    var role = this.storage.getRole();
    if(role!=undefined && role.includes(4))
      this.isOwnerUser = true;
  }

  doAction(): void{
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

    this.service.getAll(0,1000).pipe().subscribe(req => {
      this.usuarios = req.body.map( usuario => {
        console.log(usuario);
        return {
          id: usuario.id,
          nombre: usuario.nombre,
          nombreCompleto: usuario.nombreCompleto,
          apellido: usuario.apellido,
          correoElectronico: usuario.correoElectronico,
          tipos: usuario.tipos

        };
      });

      this.filteredUsuarios = this.usuarioCtrl.valueChanges.pipe(
        startWith(null),
        map((usuario: Usuario | null) => usuario ? this._filter(usuario) : this.usuarios.slice()));
    });
  }

  private _filter(value: Usuario): Usuario[] {
        const filterValue = value.nombreCompleto.toLowerCase();
        this.LOCAL_DATA.nombreCompleto = value;
        return this.usuarios.filter(option => option.nombreCompleto.toLowerCase().includes(filterValue));

  }

  displayFn(value?: Usuario) {
    return value ? this.usuarios.find(_ => _.id === value.id).nombreCompleto : (value!=null ? value.nombreCompleto: this.LOCAL_DATA.nombreCompleto);
  }

  setLocal(option):void{
    this.LOCAL_DATA.nombre = option.nombre;
    this.LOCAL_DATA.categoria = option.categoria;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if(this.LOCAL_DATA.usuarios == undefined){
      this.LOCAL_DATA.usuarios = [];
    }

    const tiene = this.findUsuario(event.option.value);

    if (!tiene) {
      this.LOCAL_DATA.usuarios.push(event.option.value);
    }
    this.usuarioInput.nativeElement.value = '';
    this.usuarioCtrl.setValue(null);
    this.usuarioInput.nativeElement.blur();
  }

  remove(user: any): void {

    this.serviceEJS.userHasEvalsInNode(user.id,this.LOCAL_DATA.id).pipe().subscribe(req => {
      if(!req.body || this.LOCAL_DATA.id ==null) {
        this.removeUserFromeNode(user);
      }else{
        this.openSnackBar("El usuario es Dueño en 1 o más evaluaciones del Nodo.","Cerrar");
      }
    });
  }

  removeUserFromeNode(user:any):void{
    const index = this.LOCAL_DATA.usuarios.indexOf(user);

    if (index >= 0) {
      this.LOCAL_DATA.usuarios.splice(index, 1);
    }
  }

  findUsuario(usuario): boolean{
    var tiene = false;
    for(var i=0; i<this.LOCAL_DATA.usuarios.length;i++){
      if(this.LOCAL_DATA.usuarios[i].id == usuario.id){
        tiene = true;
        break;
      }
    }

    this.LOCAL_DATA.usuarios = [...this.LOCAL_DATA.usuarios];

    return tiene;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.LOCAL_DATA.evaluaciones.length;
    return numSelected === numRows;
  }

  checkboxLabel(row?: Evaluacion): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    //return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row`;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.LOCAL_DATA.evaluaciones.forEach(row => this.selection.select(row));
  }

  openDialog(): void {
    var user = this.storage.getUser();
    //var obj = {usuario: user};
    var obj = {usuario: user};
    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: obj,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      //this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
      var obj = {action: "Copy", nodo: this.LOCAL_DATA, destino:result.data.nodo};
      const dialogRef = this.dialog.open(DialogBoxCopyEvaluationsToOtherStructureComponent, {
        width: '100%',
        data: obj,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        //this.LOCAL_DATA.nodoEstructuraJerarquica = result.data.nodo;
      });
    });
  }


}
